import { render } from "./SortAlphabeticalAscending.vue.js?vue&type=template&id=6ef9b586!=!../vue-loader/dist/index.js??ruleSet[0]!./SortAlphabeticalAscending.vue?vue&type=template&id=6ef9b586"
import script from "./SortAlphabeticalAscending.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./SortAlphabeticalAscending.vue?vue&type=script&lang=js"
export * from "./SortAlphabeticalAscending.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./SortAlphabeticalAscending.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__